import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="table-filter"
export default class extends Controller {
  static targets = ["input", "row"];

  filter() {
    const query = this.inputTarget.value.toLowerCase();

    this.rowTargets.forEach(row => {
      const text = row.textContent.toLowerCase();
      row.style.display = text.includes(query) ? "" : "none";
    });
  }
}
